var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageplugIconMint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144.73 179.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #27b7b7;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m65.08,37.83h19.24l-2.17,9.76c3.11-3.79,6.46-6.63,10.05-8.51,3.59-1.88,7.42-2.82,11.49-2.82,6.43,0,11.51,2.12,15.23,6.36,3.72,4.24,5.58,10.02,5.58,17.33,0,4.99-.68,10.01-2.04,15.04-1.36,5.03-3.26,9.6-5.71,13.7-3.02,4.99-6.83,8.88-11.43,11.67-4.6,2.79-9.46,4.18-14.58,4.18s-8.93-1.2-12.08-3.6c-3.15-2.4-5.17-5.77-6.04-10.1l-6.58,29.97c2.88.79,5.85,1.38,8.91,1.75,34.04,4.19,65.07-19.74,69.3-53.46C148.48,35.39,124.32,4.67,90.27.48c-14.17-1.74-27.8,1.4-39.21,8.07l-23.13-3.95L0,131.45l33.26,48.28,15.08-66.91m38.94-22.09c4.86,0,9.05-2.75,12.57-8.25,3.52-5.5,5.29-12.14,5.29-19.92,0-3.91-.91-6.95-2.72-9.12-1.82-2.17-4.35-3.25-7.58-3.25-4.99,0-9.31,2.68-12.97,8.04-3.66,5.36-5.48,11.87-5.48,19.54,0,4.03.98,7.19,2.95,9.49,1.97,2.3,4.62,3.45,7.95,3.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageplugIconMint);
export default __webpack_public_path__ + "static/media/pageplug_icon_mint.6baafc97d26fcf67756c12e35b71bc58.svg";
export { ForwardRef as ReactComponent };